module.exports = {
          srcSet: __webpack_public_path__ + "84137fdefce0ccf4e610db9d0f496960-122.png"+" 122w",
          images:[ {path: __webpack_public_path__ + "84137fdefce0ccf4e610db9d0f496960-122.png",width: 122,height: 96}],
          src: __webpack_public_path__ + "84137fdefce0ccf4e610db9d0f496960-122.png",
          toString:function(){return __webpack_public_path__ + "84137fdefce0ccf4e610db9d0f496960-122.png"},
          
          width: 122,
          height: 96
        }